<template>
  <svg baseProfile="full"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:ev="http://www.w3.org/2001/xml-events"
    :width="globalWidth" :height="globalHeight" class="chart bg-transparent">

    <defs>
      <filter x="0" y="0" width="1" height="1" id="bg-text">
        <feFlood flood-color="white"/>
        <feComposite in="SourceGraphic" operator="atop" />
      </filter>
    </defs>

    <!--
    <rect x="1" y="1" width="99.9%" height="99.9%" style="stroke:red; stroke-width:1; fill:none;"/>
    -->

    <!-- Вспомогательные вертикальные линии идущие из меток оси X до верха плоскости -->
    <g class="x" v-if="settings.grid.vertical" :class="responsive.x">
      <line v-for="(g, index) in vGuards" :key="index" :x1="`${g.x1}%`" :y1="`${g.y1}%`" :x2="`${g.x2}%`" :y2="`${g.y2}%`"/>
    </g>

    <!-- Вспомогательные горизонтальные линии идущие из меток оси Y до правой стороны плоскости -->
    <g class="y" v-if="settings.grid.horizontal" :class="responsive.y">
      <line v-for="(g, index) in hGuards" :key="index" :x1="`${g.x1}%`" :y1="`${g.y1}%`" :x2="`${g.x2}%`" :y2="`${g.y2}%`"/>
    </g>

    <slot  />

    <!-- Метки по оси Y -->
    <g v-if="!settings.axis.hidden.y" class="y" :class="responsive.y">
      <text filter="url(#bg-text)" v-for="(label, index) in yLabels" :key="index" :x="`${label.x}%`" :y="`${label.y}%`"
        :fill="settings.style.label.y.fill">
        <tspan dy="-4">{{ label.text }}</tspan>
      </text>
    </g>

    <!-- Метки по оси X -->
    <g v-if="!settings.axis.hidden.x" class="x" :class="responsive.x">
      <text v-for="(label, index) in xLabels" :key="index" :x="`${label.x}%`" :y="`${label.y}%`"
        :fill="settings.style.label.x.fill">
        <tspan v-if="xLabelVisible(index, xLabels.length)" dy="35px">{{ label.text }}</tspan>
      </text>
    </g>

    <!--
    <svg v-if="backwardPointerVisible" class="svg-x-window-control" :x="`${xLabels[0].x}%`" :y="`${xLabels[0].y}%`" width="35px" height="35px" viewBox="0 0 100 100"
      @click="shiftXDomainWindowBackward">
      <svg x="-50px" y="35px" width="100%" height="100%">
        <path transform="scale(-1, 1) translate(-100, 0)"
          d="m 0 50 a 25 25 0 0 1 25 -25 l 10 0 a 10 10 0 0 0 10 -10 l 0 -5 a 10 10 0 0 1 10 -10 a 10 10 0 0 1 10 5 l 25 35 a 15 15 0 0 1 0 20 l -25 35 a 10 10 0 0 1 -10 5 a 10 10 0 0 1 -10 -10 l 0 -5 a 10 10 0 0 0 -10 -10 l -10 0 a 25 25 0 0 1 -25 -25 Z"
          stroke="#829AB1" stroke-width="2" fill="white" stroke-linejoin="round" />
      </svg>
    </svg>
    -->

    <svg v-if="backwardPointerVisible" class="svg-x-window-control" :x="`${xLabels[0].x}%`" :y="`${xLabels[0].y}%`" width="35px" height="35px" viewBox="0 0 100 100"
      @click="shiftXDomainWindowBackward">
      <svg x="-50px" y="35px" width="100%" height="100%">
        <path d="m 0 50 a 50 50 0 0 1 100 0 a 50 50 0 0 1 -100 0 Z"
          stroke="#99abb8" stroke-width="2" fill="white" stroke-linejoin="round" />
        <path d="m 57 30 l -20 20 l 20 20 m -20 -20 m 20 -20 Z"
          stroke="#99abb8" stroke-width="2" fill="white" stroke-linejoin="round" />
      </svg>
    </svg>

    <!--
    <svg v-if="forwardPointerVisible" class="svg-x-window-control" :x="`${xLabels.slice(-1)[0].x}%`" :y="`${xLabels[0].y}%`" width="35px" height="35px" viewBox="0 0 100 100"
      @click="shiftXDomainWindowForward">
      <svg x="-50px" y="35px" width="100%" height="100%">
        <path d="m 0 50 a 25 25 0 0 1 25 -25 l 10 0 a 10 10 0 0 0 10 -10 l 0 -5 a 10 10 0 0 1 10 -10 a 10 10 0 0 1 10 5 l 25 35 a 15 15 0 0 1 0 20 l -25 35 a 10 10 0 0 1 -10 5 a 10 10 0 0 1 -10 -10 l 0 -5 a 10 10 0 0 0 -10 -10 l -10 0 a 25 25 0 0 1 -25 -25 Z"
          stroke="#829AB1" stroke-width="2" fill="white" stroke-linejoin="round"/>
      </svg>
    </svg>
    -->

    <svg v-if="forwardPointerVisible" class="svg-x-window-control" :x="`${xLabels.slice(-1)[0].x}%`" :y="`${xLabels[0].y}%`" width="35px" height="35px" viewBox="0 0 100 100"
      @click="shiftXDomainWindowForward">
      <svg x="-50px" y="35px" width="100%" height="100%">
        <path d="m 0 50 a 50 50 0 0 1 100 0 a 50 50 0 0 1 -100 0 Z"
          stroke="#99abb8" stroke-width="2" fill="white" stroke-linejoin="round" />
        <path transform="scale(-1, 1) translate(-100, 0)" d="m 57 30 l -20 20 l 20 20 m -20 -20 m 20 -20 Z"
          stroke="#99abb8" stroke-width="2" fill="white" stroke-linejoin="round" />
      </svg>
    </svg>

  </svg>
</template>

<script>
/**
 * Базовая плоскость. Встраиваемые в нее графики должны иметь общее, (сопоставимое и пересекающееся) координатное пространство
 * @displayName Базовый компонент-плоскость в который в виде слотов встраиваются дочерние графики
 */
export default {
  props: {
    /**
     * Общая конфигурация плоскости. Формат такой же как в defaultConfig
     * Переданный сюда config мержиться с defaultConfig
     */
    config: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      // переданный в prop config мержится с settings
      settings: {
        // Конфигурация отображения сетки
        grid: {
          vertical: true, // отображать ли вертикальные линии сетки
          horizontal: true // отображать ли горизонтальные линии сетки
        },
        // Пользователь может задавать свои ОТОБРАЖАЕМЫЕ значения на шкалах осей с метками
        axis: {
          // список отметок со значениями по оси Х [{ value: 0, label: "Авг" }, { value: 1, label: "Сен" }]
          x: null,
          // список отметок со значениями по оси Y [{ value: 0, label: "Мало" }, { value: 100, label: "Много" }],
          y: null,
          // максимальное отображаемое кол-во делений по шкале X
          // если по факту кол-во делений по X больше размера окна, то появляется прокрутка по ОСИ X
          // это окно и двигается по ОСИ X
          windowSize: 6,
          // кол-во делений на осях
          division: {
            x: 10, // максимальное кол-во отметок по оси X (учитываетс если не задано axis.x)
            y: 7 // максимальное кол-во отметок по оси X (учитываетс если не задано axis.x)
          },
          // Если высота плоскости состоит из набора элементов заданной высоты, например горизонтальные бары 30px
          // тогда задаем высоту такого бара, например discreteHeight: 30. При этом должна быть задана шкала axis.y
          discreteHeight: null,
          // аналогично discreteHeight
          discreteWidth: null,
          // не рисовать отметки на осях
          hidden: {
            x: false,
            y: false
          }
        },
        /**
         * Размеры области где рисуется график, выражены в процентах.
         * Метки осей располагаются вне этой области слева и справа
         * Например, если слева нужно половину места отдать для длинных меток оси Y, то
         * можно задать следующие параметры x: 50, width: 50
         */
        chartArea: {
          // y: 10 - отступ свеху чтобы в область SVG влезли самые верхние показатели
          // width: 75 a не 85 чтобы  в область SVG влезла правая метка по оси X
          // но вообще если что-то будет торчать это не критично, можно поместить график в div
          // и сделать ему нужный padding
          x: 15, y: 0, width: 75, height: 100
        },
        style: {
          label: {
            x: { fill: '#99abb8', reponsive: true },
            y: { fill: '#99abb8', reponsive: true }
          }
        }
      },
      // дочерние компоненты рисуются в этом viewBox
      viewBox: { x: 0, y: 0, width: 300, height: 200 },
      xDomainRange: null,
      yDomainRange: null,
      xDomainWindow: null,
      mappers: null,
      yLabels: [],
      xLabels: [],
      hGuards: [],
      vGuards: []
    }
  },
  computed: {
    globalWidth () {
      return Number.isInteger(this.settings.axis.discreteWidth)
        // ? `${this.settings.axis.discreteWidth * this.settings.axis.x.length * 100 / this.settings.chartArea.width}`
        ? `${this.settings.axis.discreteWidth * this.settings.axis.x.length}px`
        : '100%'
    },
    globalHeight () {
      if (Number.isInteger(this.settings.axis.discreteHeight)) {
        const dh = this.settings.axis.discreteHeight
        const summaryItemsHeght = Math.max(this.settings.axis.y.length * dh - dh, dh)
        // const svgHeight = summaryItemsHeght * 100 / this.settings.chartArea.height
        return `${summaryItemsHeght}px`
      } else {
        return '200px'
      }
    },
    isXAxisUserPredefined () {
      return Array.isArray(this.settings.axis.x)
    },
    isYAxisUserPredefined () {
      return Array.isArray(this.settings.axis.y)
    },
    responsive () {
      return {
        x: this.settings.style.label.x.reponsive ? 'responsive_x' : '',
        y: this.settings.style.label.y.reponsive ? 'responsive_y' : ''
      }
    },
    backwardPointerVisible () {
      return this.xDomainWindow
        ? this.xDomainWindow.min > this.settings.axis.x[0].value
        : false
    },
    forwardPointerVisible () {
      return this.xDomainWindow
        ? this.xDomainWindow.max < this.settings.axis.x.slice(-1)[0].value
        : false
    }
  },
  created () {
    this.$lo.merge(this.settings, this.config)
  },
  mounted () {
    this.render()
  },
  /**
  * Эти методы пробрасываются дочерним компонентам
  * function () не заменять на () => {... иначе ничего не работает!
  */
  provide: function () {
    return {
      /**
      * Этот метод сообщает дочернему компоненту относительный размер его SVG
      */
      getSvg: () => this.settings.chartArea,
      /**
      * Этот метод сообщает дочернему компоненту размер его viewBox
      */
      getViewBox: () => this.viewBox,
      /**
      * Этот метод дочерний компонент должен вызвать если изменились данные для графиков
      */
      childDataUpdated: () => {
        this.$nextTick(() => {
          this.render()
        })
      }
    }
  },
  methods: {
    /**
    * Расчет всех характеристик на основе дочерних компонентов и отрисовка графиков
    */
    render () {
      this.initGlobalDomainRange()
      this.initXDomainWindow()

      this.makeMappers()

      this.isYAxisUserPredefined
        ? this.renderUserYLabes()
        : this.renderDefaultYLabes()

      this.isXAxisUserPredefined
        ? this.renderUserXLabes()
        : this.renderDefaultXLabes()

      this.renderHGuards()
      this.renderVGuards()

      this.$children.map(child => child.render(this.mappers))
    },
    /**
     * Получает {max, min} диапазоны значений по осям X и Y у дочерних компонентов
     * и формирует обощенный диапазон по оси X -> this.xDomainRange {min, max}
     * и по оси Y -> this.yDomainRange {min, max}, для того чтобы сформировать общую плоскоть для всех графиков
     * Формат дипазона который должен вернуть дочерний компонент:
     *   {min: <N>, max: <N>, absolute: <true/fase>}
     * absolute = false - указывает на то, что диапазон можно сдвигать, т.е. он выражен в относительных величинах
     * или, иными словами, главное в нем размер, а где он будет начинаться не важно
     */
    initGlobalDomainRange () {
      let { xDRanges, yDRanges } = this.getChildDomainRanges()

      xDRanges = xDRanges.concat(this.getUserDefinedAxisDomainRange(this.config?.axis?.x))
      yDRanges = yDRanges.concat(this.getUserDefinedAxisDomainRange(this.config?.axis?.y))

      const absoluteXDRange = this.unionRanges(xDRanges.filter(range => range.absolute))
      const absoluteYDRange = this.unionRanges(yDRanges.filter(range => range.absolute))

      const relativeXDRange = this.unionRanges(this.alignRangesToZero(xDRanges.filter(range => !range.absolute)))
      const relativeYDRange = this.unionRanges(this.alignRangesToZero(yDRanges.filter(range => !range.absolute)))

      this.xDomainRange = this.mergeAbsoluteWithRelativeRanges(absoluteXDRange, relativeXDRange)
      this.yDomainRange = this.mergeAbsoluteWithRelativeRanges(absoluteYDRange, relativeYDRange)
    },
    /**
    * Инициализируем окно по доменным данным оси X
    */
    initXDomainWindow () {
      if (this.settings.axis.x === null || this.settings.axis.x.length < 2) {
        this.xDomainWindow = null
      } else {
        if (this.xDomainWindow === null) {
          const step = this.settings.axis.x[1].value - this.settings.axis.x[0].value
          const length = this.settings.axis.windowSize * step
          const min = Math.max(this.settings.axis.x.slice(-1)[0].value - length, this.settings.axis.x[0].value)

          this.xDomainWindow = {
            step: step,
            min: min,
            max: min + length
          }
        } else {
          // this.xDomainWindow у
        }
      }
    },
    shiftXDomainWindowForward () {
      if (this.xDomainWindow) {
        const length = this.settings.axis.windowSize * this.xDomainWindow.step
        const step = this.xDomainWindow.step
        let min = this.xDomainWindow.min + this.xDomainWindow.step
        if (min + length > this.settings.axis.x.slice(-1)[0].value) {
          min = this.xDomainWindow.min
        }
        const max = min + length
        this.xDomainWindow = { step, min, max }
        this.render()
      }
    },
    shiftXDomainWindowBackward () {
      if (this.xDomainWindow) {
        const step = this.xDomainWindow.step
        const min = Math.max(this.xDomainWindow.min - this.xDomainWindow.step, this.settings.axis.x[0].value)
        const max = min + this.settings.axis.windowSize * this.xDomainWindow.step
        this.xDomainWindow = { step, min, max }
        this.render()
      }
    },
    /**
    * Получает диапазоны данных по осям X и Y у дочерних компонентов
    */
    getChildDomainRanges () {
      const ranges = this.$children.reduce((acc, child) => {
        const { xDRange, yDRange } = child.getDomainRange()
        acc[0].push(xDRange)
        acc[1].push(yDRange)
        return acc
      }, [[], []])
      return { xDRanges: ranges[0], yDRanges: ranges[1] }
    },
    /**
    * Получает диапазоны данных по оси переданной в параметр и заданной пользователем вместе с метками по данной оси
    */
    getUserDefinedAxisDomainRange (axisItems) {
      if (Array.isArray(axisItems)) {
        return [{
          min: Math.min(...axisItems.map(d => d.value)),
          max: Math.max(...axisItems.map(d => d.value)),
          absolute: true
        }]
      } else {
        return []
      }
    },
    /**
    * Объединение списка диапазонов в один диапазон
    */
    unionRanges (ranges) {
      return ranges.reduce((acc, range) => {
        return {
          min: acc ? Math.min(acc.min, range.min) : range.min,
          max: acc ? Math.max(acc.max, range.max) : range.max
        }
      }, null)
    },
    /**
    * Сдвигает диапазон к нулю
    * Это нужно для графиков у которых нет точной начальной координаты Y, но есть область по оси Y которую они должны занять
    * Диапазоны таких графиков сдвигаются к нулю, чтобы привести их к общему "знаменателю"
    */
    alignRangesToZero (ranges) {
      // сдвигаем ренджи так, чтобы их начало попало на ноль
      return ranges.map(range => {
        return { min: 0, max: range.max - range.min }
      })
    },
    /**
    * Объединение абсолютного диапазон с относительным
    * Абсолютный диапазон имеет четкое начало min и конец max
    * Относительный диапазон тоже имеет начало min и конец max, но его начало можно сдвинуть куда угодно,
    * главное чтобы длинна относительного диапазона осталась такой же
    * В данной функции диапазоны сопоставляются так, чтобы графики были как можно ближе к центру плоскости
    */
    mergeAbsoluteWithRelativeRanges (absolute, relative) {
      if (absolute && relative && this.rangeLength(absolute) < this.rangeLength(relative)) {
        const handyMin = absolute.min - ((this.rangeLength(relative) - this.rangeLength(absolute)) / 2)
        const min = Math.max(handyMin, 0)
        return {
          min: min,
          max: min + this.rangeLength(relative)
        }
      } else {
        return absolute || relative
      }
    },
    /**
    * Длинная диапазона
    */
    rangeLength (range) {
      return range.max - range.min
    },
    /**
    * Значение в диапазоне
    */
    inRange (value, range) {
      return value >= range.min && value <= range.max
    },
    /**
    * Формирует функции для отображения данных дочерних компонентов в координаты точек на плоскости
    */
    makeMappers () {
      this.mappers = {
        real: this.makeRealMappers(),
        percent: this.makePercentMappers(),
        relative: this.makeRelativeMappers(),
        length: this.makeLengthMappers()
      }
    },
    /**
    * Формирует функции для отображения данных дочерних компонентов в реальную координату точки на плоскости (в рамках viewBox)
    * Это функции пробрасываются всем дочерним компонентам
    */
    makeRealMappers () {
      const viewBoxXRange = { min: this.viewBox.x, max: this.viewBox.x + this.viewBox.width }
      const viewBoxYRange = { min: this.viewBox.y + this.viewBox.height, max: this.viewBox.y }

      const xDomainRange = this.xDomainWindow ? this.xDomainWindow : this.xDomainRange

      // const x = this.valueScale(this.xDomainRange, viewBoxXRange)
      const x = value => this.projectValueOntoRange(value, xDomainRange, viewBoxXRange)
      // const y = this.valueScale(this.yDomainRange, viewBoxYRange)
      const y = value => this.projectValueOntoRange(value, this.yDomainRange, viewBoxYRange)

      return { x, y }
    },
    /**
    * Формирует функции для отображения данных дочерних компонентов в координату точки на плоскости выраженную в процентах
    * Эти функции пробрасываются всем дочерним компонентам
    * Отличие этих маперов от предыдущих в том, что они отражают данные в координаты плоскости выраженные в процентах
    * это нужно для того, чтобы дочерние элементы могли отображать метки, надписи которых не искажаются
    * при искажении сторон плоскоти графиков
    */
    makePercentMappers () {
      // const viewBoxXRange = { min: 0, max: 100 }
      // const viewBoxYRange = { min: 100, max: 0 }

      const xDomainRange = this.xDomainWindow ? this.xDomainWindow : this.xDomainRange

      // const x = this.valueScale(this.xDomainRange, viewBoxXRange)
      const x = value => this.projectValueOntoRange(value, xDomainRange, { min: 0, max: 100 })
      // const y = this.valueScale(this.yDomainRange, viewBoxYRange)
      const y = value => this.projectValueOntoRange(value, this.yDomainRange, { min: 100, max: 0 })

      return { x, y }
    },
    /**
    * Формирует функции для отображения данных дочерних компонентов в реальную координату точки на плоскости (в рамках viewBox)
    * Это функции пробрасываются всем дочерним компонентам
    * На вход этим маперам дается значние от 0 до 1 и оно преобразуется в реальную координату viewBox
    */
    makeRelativeMappers () {
      const viewBoxXRange = { min: this.viewBox.x, max: this.viewBox.x + this.viewBox.width }
      const viewBoxYRange = { min: this.viewBox.y + this.viewBox.height, max: this.viewBox.y }

      // const x = this.valueScale({ min: 0, max: 1 }, viewBoxXRange)
      const x = value => this.projectValueOntoRange(value, { min: 0, max: 1 }, viewBoxXRange)
      // const y = this.valueScale({ min: 0, max: 1 }, viewBoxYRange)
      const y = value => this.projectValueOntoRange(value, { min: 0, max: 1 }, viewBoxYRange)

      return { x, y }
    },
    /**
    * Формирует функции для отображения отрезков данных дочерних компонентов в отрезок плоскости (в рамках viewBox)
    * Это функции пробрасываются всем дочерним компонентам
    * На вход этим маперам дается длинна и она преобразуется в соотв. длинну на viewBox
    */
    makeLengthMappers () {
      const viewBoxXRange = { min: this.viewBox.x, max: this.viewBox.x + this.viewBox.width }
      const viewBoxYRange = { min: this.viewBox.y, max: this.viewBox.y + this.viewBox.height }

      const xDomainRange = this.xDomainWindow ? this.xDomainWindow : this.xDomainRange

      // const x = this.lengthScale(this.xDomainRange, viewBoxXRange)
      const x = length => this.projectLengthOntoRange(length, xDomainRange, viewBoxXRange)
      // const y = this.lengthScale(this.yDomainRange, viewBoxYRange)
      const y = length => this.projectLengthOntoRange(length, this.yDomainRange, viewBoxYRange)

      return { x, y }
    },
    /**
    * Функция масшатбирования значения данных в значение точки на плоскости
    */
    valueScale (domainRange, plotRange) {
      // const m = (plotRange.max - plotRange.min) / (domainRange.max - domainRange.min)
      // return num => plotRange.min + m * (num - domainRange.min)
      return num => this.projectValueOntoRange(num, domainRange, plotRange)
    },
    /**
    * Функция масшатбирования длинны в значение длинны на плоскости
    */
    lengthScale (domainRange, plotRange) {
      // const m = (plotRange.max - plotRange.min) / (domainRange.max - domainRange.min)
      // return length => m * length
      return length => this.projectLengthOntoRange(length, domainRange, plotRange)
    },
    /**
    * Формирование меток по оси Y
    */
    renderDefaultYLabes () {
      const labelCount = this.settings.axis.division.y
      const cSvg = this.settings.chartArea // { x: 5, y: 5, width: 90, height: 85 },
      this.yLabels = Array.from(Array(labelCount + 1).keys()).map(index => {
        const dY = this.yDomainRange.min + index * (this.rangeLength(this.yDomainRange) / labelCount)
        return { x: 0, y: ((cSvg.y + cSvg.height) - (cSvg.height / labelCount) * index), text: dY.toFixed(1) }
      })
    },
    /**
    * Формирование меток по оси Y заданных пользователем
    */
    renderUserYLabes () {
      const cSvg = this.settings.chartArea // { x: 5, y: 5, width: 90, height: 85 },
      const svgYRange = { min: cSvg.y + cSvg.height, max: cSvg.y }
      this.yLabels = this.config.axis.y.map(({ value, label }) => {
        const y = this.projectValueOntoRange(value, this.yDomainRange, svgYRange)
        return { x: 0, y: y, text: label }
      })
    },
    /**
    * Формирование меток по оси X
    */
    renderDefaultXLabes () {
      const labelCount = this.settings.axis.division.x
      const cSvg = this.settings.chartArea // { x: 5, y: 5, width: 90, height: 85 },
      this.xLabels = Array.from(Array(labelCount + 1).keys()).map(index => {
        const dX = this.xDomainRange.min + index * (this.rangeLength(this.xDomainRange) / labelCount)
        return { x: (cSvg.x + (cSvg.width / labelCount) * index), y: 100, text: dX.toFixed(1) }
      })
    },
    /**
    * Формирование меток по оси X заданных пользователем
    */
    renderUserXLabes () {
      const cSvg = this.settings.chartArea // { x: 5, y: 5, width: 90, height: 85 },
      const svgXRange = { min: cSvg.x, max: cSvg.x + cSvg.width }
      const xDomainRange = this.xDomainWindow ? this.xDomainWindow : this.xDomainRange
      this.xLabels = this.config.axis.x.map(({ value, label }) => {
        const x = this.projectValueOntoRange(value, xDomainRange, svgXRange)
        return { x: x, y: 100, text: label }
      }).filter(({ x }) => x !== null)
    },
    xLabelVisible (labelIndex, totalxLabelsCount) {
      if (this.xDomainWindow) {
        if (labelIndex === 0) {
          return !this.backwardPointerVisible
        } else if (labelIndex === totalxLabelsCount - 1) {
          return !this.forwardPointerVisible
        } else {
          return true
        }
      } else {
        return true
      }
    },
    /**
    * Отображение value из диапазона valueRange в диапазон targetRange
    */
    /*
    projectValueOntoRange (value, valueRange, targetRange) {
      if (this.rangeLength(valueRange) > 0) {
        const ratio = (value - valueRange.min) / this.rangeLength(valueRange)
        return targetRange.min + this.rangeLength(targetRange) * ratio
      } else {
        return targetRange.min
      }
    },
    */
    projectValueOntoRange (value, valueRange, targetRange) {
      if (this.rangeLength(valueRange) > 0 && this.inRange(value, valueRange)) {
        const ratio = (value - valueRange.min) / this.rangeLength(valueRange)
        return targetRange.min + this.rangeLength(targetRange) * ratio
      } else {
        return null
      }
    },
    /**
    * Отображение длинные из диапазона valueRange в длинну диапазон targetRange
    */
    projectLengthOntoRange (length, valueRange, targetRange) {
      if (this.rangeLength(valueRange) !== 0) {
        const ratio = length / this.rangeLength(valueRange)
        return this.rangeLength(targetRange) * ratio
      } else {
        return 0
      }
    },
    /**
    * Формирование вспомогательных горизонтальных линий на плоскости
    */
    renderHGuards () {
      this.hGuards = this.yLabels.map(({ x, y }) => {
        return { x1: 0, y1: y, x2: 100, y2: y }
      })
    },
    /**
    * Формирование вспомогатльных вертикальных линий на плоскости
    */
    renderVGuards () {
      this.vGuards = this.xLabels.map(({ x, y }) => {
        return { x1: x, y1: 0, x2: x, y2: 100 }
      })
    }
  }
}
</script>

<style scoped>
svg * {
  vector-effect: non-scaling-stroke;
  overflow: visible;
}
.chart {
  overflow: visible;
  padding-bottom: 45px;
}
.svg-x-window-control {
  cursor: pointer;
}
line {
  stroke: silver;
  stroke-dasharray: 3;
  stroke-width: 0.5px;
}
.x {
  text-anchor: middle;
}
.y {
  text-anchor: start;
}
.x, .y {
  font-size: 14px;
}
.responsive_x text, .responsive_x line, .responsive_y text, .responsive_y line {
  display: none;
}
@media only screen and (max-width: 30em) {
  .responsive_x text:nth-child(3n-2), .responsive_x line:nth-child(3n-2),
  .responsive_y text:nth-child(2n-1), .responsive_y line:nth-child(2n-1) {
    display: block;
  }
}
@media only screen and (min-width: 30em) and (max-width: 80em) {
  .responsive_x text:nth-child(2n-1), .responsive_x line:nth-child(2n-1),
  .responsive_y text:nth-child(2n-1), .responsive_y line:nth-child(2n-1) {
    display: block;
  }
}
@media only screen and (min-width: 80em) {
  .responsive_x text, .responsive_x line, .responsive_y text, .responsive_y line {
    display: block;
  }
}
</style>
